/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormArray } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { AppFormGroup, toAppFormArray } from '@gh/common-shared';
import { getControl } from '@gh/core-ui';

import { find, isEmpty } from 'lodash';
import { UomSharedListItem } from '../../../../resources/component-and-item-details.model';
import { ImportPriceNewItem } from '../../../../resources/estimating-import-price-tab.model';

import { EstimatingimportPriceTabFormState } from '../../estimating-import-price-tab-form.service';

@Component({
  standalone: false,
  selector: 'gh-estimating-import-price-new-items-subtab',
  templateUrl: 'import-price-new-items-subtab.component.html',
  styleUrls: ['import-price-new-items-subtab.component.scss'],
})
export class ImportPriceNewItemsSubtabComponent {

  @Input() uoms: UomSharedListItem[];
  @Input() items: ImportPriceNewItem[] = [];
  @Input() form: EstimatingimportPriceTabFormState;
  @Input() selectedItems: AppFormGroup[] = [];

  @Output() selectItem: EventEmitter<AppFormGroup> = new EventEmitter<AppFormGroup>();
  @Output() deselectItem: EventEmitter<AppFormGroup> = new EventEmitter<AppFormGroup>();
  @Output() selectAll: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() invalidError: EventEmitter<AppFormGroup> = new EventEmitter<AppFormGroup>();

  @ViewChild(CdkVirtualScrollViewport, { static: false }) virtualScroll: CdkVirtualScrollViewport;

  onNewItemSelectionChanged($event: MatCheckboxChange, itemGroup: AppFormGroup): void {
    this.form.updateSchemaItemGroupRequired(itemGroup, $event.checked);
    if ($event.checked) {
      this.selectItem.emit(itemGroup);
    } else {
      this.deselectItem.emit(itemGroup);
    }
  }

  onNewItemsSelectAll($event: MatCheckboxChange): void {
    this.selectAll.emit($event.checked);
  }

  inSelectedItems(itemGroup: AppFormGroup): boolean {
    return Boolean(find(this.selectedItems,
                        (selectedItemGroup: AppFormGroup): boolean =>
        selectedItemGroup.getRawValue().code === itemGroup.getRawValue().code));
  }

  isSelectedAll(): boolean {
    const itemsGroup = <FormArray>getControl(this.form.group, 'items');
    return !isEmpty(itemsGroup.controls)
      && this.selectedItems.length === itemsGroup.controls.length;
  }

  isSelectedPartial(): boolean {
    const itemsGroup = <FormArray>getControl(this.form.group, 'items');
    return !isEmpty(itemsGroup.controls)
      && !isEmpty(this.selectedItems)
      && this.selectedItems.length < itemsGroup.controls.length;
  }

  scrollTo(newItem: AppFormGroup): void {
    const itemsArray = toAppFormArray(getControl(this.form.group, 'items'));
    const newItemIndex = itemsArray.controls.indexOf(newItem);
    if (newItemIndex >= 0) {
      this.virtualScroll.scrollToIndex(newItemIndex);
    }
  }
}
